import { render, staticRenderFns } from "./JdhBackButton.vue?vue&type=template&id=2882a2de&scoped=true&"
import script from "./JdhBackButton.vue?vue&type=script&lang=ts&"
export * from "./JdhBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./JdhBackButton.vue?vue&type=style&index=0&id=2882a2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882a2de",
  null
  
)

export default component.exports